import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import _get from 'lodash/get';
import Grid from '@material-ui/core/Grid';
import { FastField, Field } from 'formik';
import OutlinedSelectInput from '../../../../components/Global/Inputs/OutlinedSelect';
import TextFieldInput from '../../../../components/Global/Inputs/TextField';
import { withNamespaces } from 'react-i18next';
import combineStyles from '../../../../utils/combineStyles';
import SpacingStyles from '../../../../styles/helpers/spacing';
import { withStyles } from '@material-ui/core/styles';
import { AppContext } from '../../../../AppProvider';
import LayoutStyles from '../../../../styles/layout';
import GridItem from './../../../Global/GridItem';
import _isEqual from 'lodash/isEqual';
import PhoneField from './../../../Global/Inputs/PhoneField';
import Autocomplete from './../../../Global/Inputs/Autocomplete';
import { getContactSuggestions } from '../helpers';

export class Hazmat extends Component {
  static propTypes = {
    hazMat: PropTypes.shape({
      properShippingName: PropTypes.string,
      hazMatClassId: PropTypes.string,
      unNumber: PropTypes.string
    }),
    productNumber: PropTypes.number.isRequired,
    unitNumber: PropTypes.number.isRequired,
    handleChange: PropTypes.func.isRequired,
    handleValidateField: PropTypes.func.isRequired,
    contacts: PropTypes.array,
    setFieldValue: PropTypes.func.isRequired
  };
  shouldComponentUpdate(nextProps) {
    if (!_isEqual(nextProps.hazMat, this.props.hazMat)) {
      return true;
    }
    return false;
  }

  _onHazMatContactChanged = (change, productField, field) => {
    const { setFieldValue } = this.props;
    setFieldValue(`${productField}.product.hazMat.${field}`, change);
  };

  _handleContactSelected = ({ data: contact }, productField) => {
    const { setFieldValue } = this.props;
    setFieldValue(
      `${productField}.product.hazMat.contactFirstName`,
      contact.firstName
    );
    setFieldValue(
      `${productField}.product.hazMat.contactLastName`,
      contact.lastName
    );
    setFieldValue(`${productField}.product.hazMat.contactPhone`, contact.phone);
  };

  render() {
    const {
      handleChange,
      handleValidateField,
      hazMat,
      unitNumber,
      productNumber,
      t,
      classes,
      contacts = []
    } = this.props;

    const {
      hazMatClasses,
      hazMatPackingGroups
    } = this.context.globalProps.referenceData;
    const {
      orgInfo: {
        config: { defaultCountry }
      }
    } = this.context.globalProps;

    const productField = `handlingUnits[${unitNumber}].shipmentItems[${productNumber}]`;
    return (
      <Fragment>
        <Grid item container spacing={16}>
          <GridItem lg={6}>
            <FastField
              value={_get(hazMat, 'properShippingName', '')}
              name={`${productField}.product.hazMat.properShippingName`}
              label={t('Proper Shipping Name')}
              onChange={handleChange}
              component={TextFieldInput}
              classes={{
                root: classes.noMarginBottom
              }}
              validateField={handleValidateField}
            />
          </GridItem>
          <GridItem lg={3}>
            <FastField
              name={`${productField}.product.hazMat.hazMatClassId`}
              onChange={handleChange}
              render={({ field, form }) => {
                return (
                  <OutlinedSelectInput
                    value={_get(hazMat, 'hazMatClassId', 'NONE')}
                    field={field}
                    form={form}
                    label={t('HazMat Class')}
                    options={hazMatClasses}
                    multiple={false}
                    validateField={handleValidateField}
                    classes={{
                      root: classes.noMarginBottom
                    }}
                  />
                );
              }}
            />
          </GridItem>
          <GridItem lg={3}>
            <FastField
              value={_get(hazMat, 'unNumber', '')}
              name={`${productField}.product.hazMat.unNumber`}
              label={t('UN/NA')}
              onChange={handleChange}
              component={TextFieldInput}
              validateField={handleValidateField}
              classes={{
                root: classes.noMarginBottom
              }}
            />
          </GridItem>
          <GridItem lg={4}>
            <FastField
              name={`${productField}.product.hazMat.hazMatPackingGroupId`}
              onChange={handleChange}
              render={({ field, form }) => {
                return (
                  <OutlinedSelectInput
                    value={_get(hazMat, 'hazMatPackingGroupId', '')}
                    field={field}
                    form={form}
                    label={t('Packing Group')}
                    options={hazMatPackingGroups}
                    multiple={false}
                    validateField={handleValidateField}
                    classes={{
                      root: classes.noMarginBottom
                    }}
                  />
                );
              }}
            />
          </GridItem>
          <GridItem lg={4}>
            <Field
              name={`${productField}.product.hazMat.contactFirstName`}
              render={({ field, form }) => {
                return (
                  <Autocomplete
                    value={_get(hazMat, 'contactFirstName', '') || ''}
                    getSuggestions={async searchTerm => {
                      return await getContactSuggestions(contacts, searchTerm);
                    }}
                    getSuggestionValue={suggestion => {
                      return _get(suggestion, 'data.firstName', '');
                    }}
                    onSuggestionSelected={contact =>
                      this._handleContactSelected(contact, productField)
                    }
                    label={t('Contact First Name')}
                    onChange={change => {
                      this._onHazMatContactChanged(
                        change,
                        productField,
                        'contactFirstName'
                      );
                    }}
                    validateField={handleValidateField}
                    field={field}
                    form={form}
                  />
                );
              }}
            />
          </GridItem>
          <GridItem lg={4}>
            <FastField
              value={_get(hazMat, 'contactLastName', '')}
              name={`${productField}.product.hazMat.contactLastName`}
              label={t('Contact Last Name')}
              onChange={handleChange}
              component={TextFieldInput}
              validateField={handleValidateField}
            />
          </GridItem>
          <GridItem lg={4}>
            <Field
              value={_get(hazMat, 'contactPhone', '')}
              name={`${productField}.product.hazMat.contactPhone`}
              label={t('Contact Phone')}
              onChange={handleChange}
              country={defaultCountry}
              component={PhoneField}
              validateField={handleValidateField}
            />
          </GridItem>
        </Grid>
      </Fragment>
    );
  }
}

Hazmat.contextType = AppContext;
const translatedHazMat = withNamespaces()(Hazmat);
export default withStyles(combineStyles(SpacingStyles, LayoutStyles))(
  translatedHazMat
);
